import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    clientSelectViewContainer: {
      height: '690px',
      background: '#D8D8D8',
      color: '#2A2A2A',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      margin: '0px 72px 96px 72px',
      overflow: 'hidden',
      borderRadius: '8px',
      width: 'auto !important',
      [theme.breakpoints.only('md')]: {
        height: '750px !important'
      },
      [theme.breakpoints.down('md')]: {
        height: '100%',
        margin: '0px 0px 40px 0px'
      },
      [theme.breakpoints.only('xs')]: {
        margin: '0px 16px 0px 16px'
      }
    },
    clientSelectImageBlock: {
      width: '50%',
      [theme.breakpoints.up('md')]: {
        flexBasis: '100% !important'
      },
      [theme.breakpoints.between('xs', 'sm')]: {
        width: '100%'
      }
    },
    clientSelectViewBlock: {
      background: 'white',
      color: '#2A2A2A',
      padding: '96px 24px 96px 64px',
      width: '50%',
      alignItems: 'center',
      [theme.breakpoints.up('md')]: {
        flexBasis: '100% !important'
      },
      [theme.breakpoints.between('xs', 'sm')]: {
        width: '100%'
      },
      [theme.breakpoints.down('sm')]: {
        padding: '21px 0px 25px 24px'
      }
    },
    clientSelectHeaderBox: {
      flex: 'none',
      background: 'transparent',
      margin: '0px 0px 40px 0px',
      padding: '0px 64px 0px 0px',
      [theme.breakpoints.down('sm')]: {
        margin: '0px 0px 10px 0px',
        padding: '0px 24px 0px 0px'
      }
    },
    clientSelectHeader: {
      fontWeight: 600,
      fontSize: '64px !important',
      margin: '0px !important',
      letterSpacing: 'normal !important',
      fontFamily: 'Poppins, sans-serif !important',
      textAlign: 'left',
      [theme.breakpoints.only('sm')]: {
        fontSize: '40px !important',
        textAlign: 'center'
      },
      [theme.breakpoints.only('xs')]: {
        fontSize: '24px !important',
        textAlign: 'center'
      }
    },
    clientSelectListBox: {
      height: '345px',
      background: 'transparent',
      minWidth: '100%',
      overflow: 'auto',
      [theme.breakpoints.down('sm')]: {
        height: '240px'
      }
    },
    clientSelectListItemBox: {
      flex: 'none',
      background: 'transparent',
      padding: '0px 64px 0px 0px',
      [theme.breakpoints.down('sm')]: {
        padding: '0px 24px 0px 0px'
      }
    },
    clientSelectNameContainer: {
      justifyContent: 'space-between',
      background: 'transparent',
      padding: '32px 0px 32px 0px',
      minWidth: '100%',
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        padding: '20px 0px 17px 0px'
      }
    }
  })
);
